module.exports = __webpack_public_path__ + "static/ip-ikon3-81e3a819dff1f19872094dab398332d9.png";